import styled from 'styled-components';
import { colors } from '../../../theme/style-helpers';

export const AlertWrapper = styled.div`
    width: 100%;
    background-color: ${colors.ORANGE_SHADES_LIGHT1};
    padding: 32px;
    margin: 40px auto;
`;

export const AlertTitle = styled.h4`
    font-size: 1.6rem;
    line-height: 2.4rem;
    color: ${colors.BLACK};
    margin-bottom: 2.0rem;

    .icon{
        margin-right: 10px;
    }

    span {
        font-weight: 600;
    }

    a,
    a:hover,
    a:active,
    a:visited {
        margin: 0 4px;
        color: ${colors.BLACK};
        text-decoration: underline;
        text-underline-offset: 2px;
    }

    a:hover {
        text-decoration-color: ${colors.BRAND_ORANGE};
    }
`;

export const AlertSubtitle = styled.p`
    font-size: 1.4rem;
    line-height: 1.8rem;
    color: ${colors.BLACK};
    font-weight: 600;
    margin-bottom: 1.2rem;
`;

export const AlertBody = styled.div`
    font-size: 1.4rem;
    line-height: 1.8rem;
    color: ${colors.BLACK};
    padding-left: ${(props) => ((props.hasIcon) ? '34px' : '0')};

    ul {
        list-style: none;
        padding: 0;
    }

    li {
        line-height: 2.4rem;

        &:before{
            content: '-';
            margin-right: 1.2rem;
        }
    }
`;
